// extracted by mini-css-extract-plugin
export default {"date-range-picker":"DateRangePicker_date-range-picker__a5-88"};